( function () {
	'use strict';

	function convertSecsToMins () {
		return function ( secs ) {
			secs = parseInt( secs );

			var hr      = Math.floor( secs / 3600 );
			var min     = Math.floor( ( secs - hr * 3600 ) / 60 );
			var s       = Math.floor( secs - ( hr * 3600 + min * 60 ) );
			var minutes = min;
			var seconds = '0' + s;

			if ( s > 9 ) {
				seconds = s;
			}

			if ( hr > 0 ) {
				minutes = '0' + min;

				if ( min > 9 ) {
					minutes = min;
				}

				return hr + ':' + minutes + ':' + seconds;
			}

			return minutes + ':' + seconds;
		};
	}

	angular
		.module( 'app.components' )
		.filter( 'convertSecsToMins', convertSecsToMins );
} )( );
